import { createSelector } from 'reselect'
import { selectIsKbsLoaded } from './selectIsKbsLoaded'
import { selectKnowledgeBases } from './index'

/**
 * Returns true if any KBs have completed migration to InstantDocs.
 * Returns null if KBs haven't been loaded yet.
 *
 * Used to determine if articles count should defer to backend
 * (since frontend cannot accurately filter articles by KB migration status).
 */
export const selectHasMigratedKnowledgeBases = createSelector(
  selectKnowledgeBases,
  selectIsKbsLoaded,
  (kbs, isKbsLoaded) => {
    if (!isKbsLoaded) return null
    return kbs.some(kb => kb.migrationStatus === 'completed')
  }
)
